import { ReactNode } from 'react'

export function Layer({ children }: { children: ReactNode }) {
  return (
    <div className="pointer-events-none absolute inset-0 [&>*]:pointer-events-auto">{children}</div>
  )
}
